export default __webpack_public_path__ + "static/media/welcome.15d83ee1.png";